//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import OnJob from '../staff-template';
import downTemplates from '../staff-template/slot/tem-map';
export default {
  props: {
    content: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    OnJob: OnJob
  },
  computed: {
    currentTem: function currentTem() {
      return this.downTemplates.get(this.activeName);
    }
  },
  data: function data() {
    return {
      visible: false,
      // 模版列表
      downTemplates: downTemplates,
      // taps
      activeName: '1'
    };
  }
};